var _rect, _path, _path2, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#E7F8FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2938_3073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 105,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4351 64.8756C65.156 65.1513 64.2242 65.666 63.3288 66.5667C62.4153 67.4858 61.8671 68.5151 61.6296 69.7834C61.3738 71.1804 61.5382 72.412 62.1777 73.7538C63.7856 77.1176 67.9334 78.294 71.1309 76.3088L71.5512 76.0515L74.5478 79.066C76.2105 80.7204 77.6357 82.1173 77.7454 82.1725C78.4032 82.5033 79.2071 81.8049 78.9513 81.1064C78.8965 80.9777 77.5261 79.5072 75.8268 77.8161L72.812 74.7648L73.1409 74.2317C74.7488 71.5848 74.1824 68.1843 71.807 66.1439C71.2588 65.6844 70.2356 65.1513 69.4682 64.9491C68.7373 64.7469 67.1659 64.7102 66.4351 64.8756ZM68.9566 66.6402C70.8021 67.1365 72.1907 68.9195 72.2273 70.8679C72.2273 71.7319 72.0994 72.3201 71.6974 73.0737C70.6011 75.2243 67.8785 76.0331 65.6494 74.9118C64.0232 74.0847 63.073 72.2098 63.3471 70.3349C63.5847 68.6438 64.955 67.0814 66.563 66.6586C67.1842 66.4932 68.3536 66.4932 68.9566 66.6402Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3729 37H72C73.6569 37 75 38.3431 75 40V60.2759M51.3729 37L41 47.3448M51.3729 37V45.3448C51.3729 46.4494 50.4775 47.3448 49.3729 47.3448H41M41 47.3448V79C41 80.6569 42.3431 82 44 82H61.1695M48 53H68M48 60H68M48 67H59",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8.75,
    width: 103.5,
    height: 103.5,
    rx: 51.75,
    stroke: "#0078BB",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2938_3073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 60.5C113 89.4949 89.4949 113 60.5 113C31.5051 113 8 89.4949 8 60.5C8 31.5051 31.5051 8 60.5 8C89.4949 8 113 31.5051 113 60.5Z",
    fill: "url(#paint0_linear_2938_3073)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2938_3073",
    x1: 61,
    y1: -12,
    x2: 60.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatReport);
export default __webpack_public_path__ + "static/media/feat_report.246f18fe8240f5c5c08eb1d614095de3.svg";
export { ForwardRef as ReactComponent };